import type { ColumnDef } from '@tanstack/react-table'

/**
 * The exact literal backends substitute for PII (phone numbers today) in log responses when
 * the caller's profile lacks `logs`.`view_pii`.
 */
export const REDACTED_VALUE = '[REDACTED]'

/**
 * Display formatters must pass a redacted value through untouched. A phone formatter would
 * otherwise fail to parse it and fall back to "-", which reads as "there is no number here"
 * instead of "this is hidden from you".
 */
export const isRedacted = (value?: string | null): boolean => value === REDACTED_VALUE

/**
 * Response fields the backends redact without `logs`.`view_pii`. A table column bound to one
 * of these would show "[REDACTED]" in every row, so the log tables drop the column instead.
 * The number *filters* are untouched — they carry what the user typed, not a response value.
 */
export const REDACTED_FIELDS: ReadonlySet<string> = new Set([
  'from_number',
  'to_number',
  'recipient',
])

export const withoutRedactedColumns = <TData>(
  columns: ColumnDef<TData>[],
  canViewPii: boolean,
): ColumnDef<TData>[] =>
  canViewPii
    ? columns
    : columns.filter(
        (column) => !('accessorKey' in column && REDACTED_FIELDS.has(String(column.accessorKey))),
      )
